import { render } from "./financialStats.vue?vue&type=template&id=063797b9&scoped=true"
import script from "./financialStats.vue?vue&type=script&lang=js"
export * from "./financialStats.vue?vue&type=script&lang=js"

import "./financialStats.vue?vue&type=style&index=0&id=063797b9&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063797b9"]])

export default __exports__